import { createContext } from "react";

export const AccessControlContext = createContext(null);